import { useNavigate } from "react-router-dom";
import BrandListItem from "./BrandListItem";
import { useEffect, useRef, useState } from "react";
import queryString from "query-string";
import { useDispatch, useSelector } from "react-redux";
import { getBrandBlocks } from "../../../core/actionCreators/blocksActionCreator";
import Loader from "../Loader/Loader";
import CommonPagination from "../CommonPagination/CommonPagination";
import { GET_BRAND_BLOCK_DEFAULT_PAGE_SIZE } from "../../../utils/constants";
import { isEqual, removeEmptyStringKeys } from "../../../utils/helper";


const BrandBlocks = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { brandBlocks, isLoading } = useSelector((s: any) => s.blocksStore);
  const navigateToCreateBrandBlockHandler = () => {
    navigate("/blocks/brand/create");
  };

  const [searchCriteria, setSearchCriteria] = useState({
    id: "",
    label: "",
    name: "",
    category: "",
    elementCount: "",
    status: "",
    pageNumber: 0,
    pageSize: GET_BRAND_BLOCK_DEFAULT_PAGE_SIZE,
  } as any);

  const previousSearchCriteriaRef = useRef(searchCriteria);


  useEffect(() => {
    const updatedSearchCriteria = removeEmptyStringKeys(searchCriteria);
    const stringifiedSearchCriteria = queryString.stringify(updatedSearchCriteria);
    const previousCriteria = previousSearchCriteriaRef.current;
    const searchFilterChanged = !isEqual(updatedSearchCriteria, previousCriteria);

    if (searchFilterChanged) {
      const parsedSearchCriteria: any = queryString.parse(stringifiedSearchCriteria)
      for (let key in parsedSearchCriteria) {
        if (["id", "label", "name", "category", "elementCount"].includes(key)) {
          parsedSearchCriteria.pageNumber = 0
          break
        }
      }
      dispatch(getBrandBlocks(queryString.stringify(parsedSearchCriteria), null));
      previousSearchCriteriaRef.current = updatedSearchCriteria; // Update previous criteria
    }
  }, [searchCriteria]);


  const onPageChange = (pageNumber: any) => {
    setSearchCriteria({ ...searchCriteria, pageNumber: pageNumber })
  }

  return (
    <>
      <div className="flex justify-between items-center pt-4 px-4">
        <p className="text-base text-[#343434]">Brand Blocks</p>
        <button
          onClick={navigateToCreateBrandBlockHandler}
          className="h-9 py-2 px-4 bg-blue-500 text-white font-semibold rounded shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
        >
          Create Block
        </button>
      </div>
      <div className="mt-4 campaign-list bg-white mb-[54px]">
        <table className="w-full">
          <thead className="bg-[#343434]">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[6%]">
                ID
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[24%]">
                Label
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[24%]">
                Name
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[14%]">
                Category
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[10%]">
                Elements Count
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[10%]">
                Status
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[6%]">
                Update
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[6%]">
                Delete
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="px-4 py-3 text-left text-xs text-white w-[6%]">
                <input
                  value={searchCriteria.id}
                  onChange={(e) =>
                    setSearchCriteria({ ...searchCriteria, id: e.target.value })
                  }
                  className="w-full h-7 rounded border text-[#3c3c3c] border-[#EAEAEA] p-1 outline-none text-xs"
                  type="text"
                />
              </td>
              <td className="px-4 py-3 text-left text-xs text-white w-[24%]">
                <input
                  value={searchCriteria.label}
                  onChange={(e) =>
                    setSearchCriteria({
                      ...searchCriteria,
                      label: e.target.value,
                    })
                  }
                  className="w-full h-7 rounded border text-[#3c3c3c] border-[#EAEAEA] p-1 outline-none text-xs"
                  type="text"
                />
              </td>
              <td className="px-4 py-3 text-left text-xs text-white w-[24%]">
                <input
                  value={searchCriteria.name}
                  onChange={(e) =>
                    setSearchCriteria({
                      ...searchCriteria,
                      name: e.target.value,
                    })
                  }
                  className="w-full h-7 rounded border text-[#3c3c3c] border-[#EAEAEA] p-1 outline-none text-xs"
                  type="text"
                />
              </td>
              <td className="px-4 py-3 text-left text-xs text-white w-[15%]">
                <input
                  value={searchCriteria.category}
                  onChange={(e) =>
                    setSearchCriteria({
                      ...searchCriteria,
                      category: e.target.value,
                    })
                  }
                  className="w-full h-7 rounded border text-[#3c3c3c] border-[#EAEAEA] p-1 outline-none text-xs"
                  type="text"
                />
              </td>
              <td className="px-4 py-3 text-left text-xs text-white w-[15%]">
                <input
                  value={searchCriteria.elementCount}
                  onChange={(e) =>
                    setSearchCriteria({
                      ...searchCriteria,
                      elementCount: e.target.value,
                    })
                  }
                  className="w-full h-7 rounded border text-[#3c3c3c] border-[#EAEAEA] p-1 outline-none text-xs"
                  type="text"
                />
              </td>
              <td className="px-4 py-3 text-left text-xs text-white w-[8%]">
                <select
                  value={searchCriteria.status}
                  onChange={(e) => {
                    setSearchCriteria({
                      ...searchCriteria,
                      status: e.target.value,
                    });
                  }}
                  className="w-full h-7 rounded border text-[#3c3c3c] border-[#EAEAEA] p-1 outline-none text-xs"
                >
                  <option>Select An Option</option>
                  <option value={"true"}>True</option>
                  <option value={"false"}>False</option>
                </select>
              </td>
            </tr>

            {isLoading ? (
              <Loader />
            ) : (
              <BrandListItem data={brandBlocks?.data || []} />
            )}
          </tbody>
        </table>
      </div>
      {brandBlocks?.data && (
        <CommonPagination
          data={brandBlocks}
          PAGE_SIZE={GET_BRAND_BLOCK_DEFAULT_PAGE_SIZE}
          onPageChange={onPageChange}
        />
      )}
    </>
  );
};
export default BrandBlocks;
